import { render, staticRenderFns } from "./realization-icon.vue?vue&type=template&id=fdf7a5be"
import script from "./realization-icon.vue?vue&type=script&lang=js"
export * from "./realization-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports